module.exports = __webpack_public_path__ + "img/cog-icon.6525c36c.svg";